import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { useVendorStore } from '../../store/useVendorStore';
import Loader from '../loader/Loader';

export default function AddVendor() {
    const [previewUrl, setPreviewUrl] = useState(null);
    const location = useLocation();
    const [item, setItem] = useState(null);
    const { addvendor, loading, getVendorById } = useVendorStore()
    const [formData, setFormData] = useState({
        vendorName: '',
        vendorType: 'Manufacturer',
        contactPerson: '',
        emailAddress: '',
        phoneNumber: '',
        website: '',
        address: {
            streetAddress: '',
            city: '',
            state: '',
            postalCode: '',
            country: 'United States',
        },
        additionalNotes: '',
        vendorStatus: 'Active',
        images: '',
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            const file = files[0];
            setFormData(prev => ({ ...prev, [name]: file }));
            setPreviewUrl(URL.createObjectURL(file));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Form Data:', formData);

        try {
            const data = await addvendor(formData, item)
            console.log("ADDVENDOR", data)
        } catch (error) {
            console.log(error)
        }
    };

    const getDetailFunction = async (id) => {
        if (!id) {
            return
        }
        const res = await getVendorById(id)

        if (res) {
            setFormData({
                vendorName: res?.vendorName,
                vendorType: res?.vendorType,
                contactPerson: res?.contactPerson,
                emailAddress: res?.emailAddress,
                phoneNumber: res?.phoneNumber,
                website: res?.website,
                address: res?.address,
                additionalNotes: res?.additionalNotes,
                vendorStatus: res?.vendorStatus,
                images: res?.vendorLogo
            })
            setPreviewUrl(res?.vendorLogo)
        }

    }

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("id");
        if (id) {
            setItem(id)
            getDetailFunction(id)
        }
    }, [location.search])
    return (
        <div id="dashboard-root" className="flex min-h-[1000px] w-full">
            <Sidebar />
            <main id="main-content" className="flex-1 px-10 py-8">
                <Header title="Add New Vendor" />
                <Loader loading={loading} />
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Name<span className="text-red-500 ml-1">*</span>
                            </label>
                            <input name="vendorName" type="text" value={formData.vendorName} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Vendor Type
                                <span className="text-red-500 ml-1">*</span>
                            </label>
                            <select name="vendorType" value={formData.vendorType} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                                <option value="Manufacturer">Manufacturer</option>
                                <option value="Distributor">Distributor</option>
                                <option value="Wholesaler">Wholesaler</option>
                                <option value="Retailer">Retailer</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Contact Person
                                <span className="text-red-500 ml-1">*</span>
                            </label>
                            <input name="contactPerson" type="text" value={formData.contactPerson} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Email Address<span className="text-red-500 ml-1">*</span>
                            </label>
                            <input name="emailAddress" type="email" value={formData.emailAddress} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Phone Number<span className="text-red-500 ml-1">*</span>
                            </label>
                            <input name="phoneNumber" type="tel" value={formData.phoneNumber} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Website</label>
                            <input name="website" type="url" value={formData.website} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                        </div>

                        <div className="mb-6">
                            <h4 className="text-md font-medium text-gray-800 mb-3">Address Information</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Street Address</label>
                                    <input name="streetAddress" type="text"
                                        value={formData.address.streetAddress}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            address: { ...prev.address, streetAddress: e.target.value }
                                        }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">City*</label>
                                    <input name="city" type="text"
                                        value={formData.address.city}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            address: { ...prev.address, city: e.target.value }
                                        }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">State/Province*</label>
                                    <input name="state"
                                        type="text"
                                        value={formData.address.state}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            address: { ...prev.address, state: e.target.value }
                                        }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Postal Code*</label>
                                    <input name="postalCode"
                                        type="text"
                                        value={formData.address.postalCode}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            address: { ...prev.address, postalCode: e.target.value }
                                        }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Country*</label>
                                    <select name="country"
                                        value={formData.address.country}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            address: { ...prev.address, country: e.target.value }
                                        }))}
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                                    >
                                        <option value="United States">United States</option>
                                        <option value="Canada">Canada</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Germany">Germany</option>
                                        <option value="France">France</option>
                                        <option value="Japan">Japan</option>
                                        <option value="Other">Other</option>

                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Additional Notes</label>
                            <textarea name="additionalNotes" rows="3" value={formData.additionalNotes} onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"></textarea>
                        </div>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Profile Picture</label>
                            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                                <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-2xl mb-2"></i>
                                <p className="text-sm text-gray-500">Drag and drop your image here, or click to browse</p>

                                <input
                                    type="file"
                                    accept="image/*"
                                    className="hidden"
                                    id="fileInput"
                                    onChange={handleChange}
                                    name="images"
                                />

                                <button
                                    type="button"
                                    className="mt-2 bg-white border border-gray-300 rounded-lg px-4 py-2 text-sm font-medium text-gray-700"
                                    onClick={() => document.getElementById('fileInput').click()}
                                >
                                    Browse Files
                                </button>

                                {/* Optional: show selected file name */}
                                {formData.images && (
                                    <p className="text-sm text-gray-600 mt-2">Selected: {formData.images.name}</p>
                                )}
                            </div>

                        </div>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Vendor Status</label>
                            <div className="flex space-x-4">
                                {['Active', 'Pending', 'Inactive'].map((vendorStatus) => (
                                    <label key={vendorStatus} className="flex items-center">
                                        <input type="radio" name="vendorStatus" value={vendorStatus} checked={formData.vendorStatus === vendorStatus} onChange={handleChange} className="text-primary-600 mr-2" />
                                        <span className="text-sm text-gray-700">{vendorStatus}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {previewUrl && (
                            <img src={previewUrl} alt="Preview" className="mt-2 h-20" />
                        )}

                        <div className="pt-2 pb-4 flex justify-end space-x-3 col-span-2">
                            <Link to="/vendors" className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-category-modal">Cancel</Link>
                            <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Submit</button>
                        </div>
                    </div>
                </form>
            </main>
        </div>
    );
}


//  <div class="mb-6">
//                             <h4 class="text-md font-medium text-gray-800 mb-3">Product Information</h4>
//                             <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
//                                 <div>
//                                     <label class="block text-sm font-medium text-gray-700 mb-1">Product Categories</label>
//                                     <select multiple=""
//                                         class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
//                                         <option>Medications</option>
//                                         <option>Medical Devices</option>
//                                         <option>Diagnostic Equipment</option>
//                                         <option>Supplements</option>
//                                         <option>First Aid</option>
//                                         <option>Personal Protective Equipment</option>
//                                         <option>Laboratory Supplies</option>
//                                     </select>
//                                     <p class="text-xs text-gray-500 mt-1">Hold Ctrl/Cmd to select multiple</p>
//                                 </div>
//                                 <div>
//                                     <label class="block text-sm font-medium text-gray-700 mb-1">Certification/Compliance</label>
//                                     <div class="space-y-2">
//                                         <label class="flex items-center">
//                                             <input type="checkbox" class="rounded text-primary-600 mr-2" />
//                                             <span class="text-sm text-gray-700">FDA Approved</span>
//                                         </label>
//                                         <label class="flex items-center">
//                                             <input type="checkbox" class="rounded text-primary-600 mr-2" />
//                                             <span class="text-sm text-gray-700">ISO 13485</span>
//                                         </label>
//                                         <label class="flex items-center">
//                                             <input type="checkbox" class="rounded text-primary-600 mr-2" />
//                                             <span class="text-sm text-gray-700">CE Mark</span>
//                                         </label>
//                                         <label class="flex items-center">
//                                             <input type="checkbox" class="rounded text-primary-600 mr-2" />
//                                             <span class="text-sm text-gray-700">GMP Certified</span>
//                                         </label>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>